import { clsx } from '@appvantageasia/core-utils';
import { useTranslation } from 'react-i18next';
import runtime from '@/runtime';

interface FooterProps {
    collapsed: boolean;
}
const year = new Date().getFullYear();
const Footer = ({ collapsed }: FooterProps) => {
    const { t } = useTranslation('common');
    const version = runtime.appVersion;
    const appName = runtime.organization?.legalName || runtime.appName;

    return (
        <footer
            className={clsx(
                'bg-card relative px-6 py-4',
                {
                    'ltr:xl:ml-[300px] rtl:xl:mr-[300px]': !collapsed,
                    'ltr:xl:ml-[72px] rtl:xl:mr-[72px]': collapsed,
                },
                'border-border border-t border-solid'
            )}
        >
            <div className="text-muted-foreground block md:flex md:justify-between">
                <p className="text-xs sm:mb-0 md:text-sm">{t('common:copyright', { year, version, appName })}</p>
            </div>
        </footer>
    );
};

export default Footer;
